export enum ServerABTestType {
	page = 'page',
	layout = 'layout',
}
